import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { StudioBadge } from './types.js';

/** Badge component for studio switcher. */
export const Badge = ({ label, tone }: StudioBadge): ReactElement => {
  const getToneClasses = (tone: StudioBadge['tone']) => {
    switch (tone) {
      case 'success':
        return 'text-success border-success';
      case 'info':
        return 'text-primary border-primary';
      case 'neutral':
        return 'text-muted border-muted';
      default:
        return 'text-muted border-muted';
    }
  };

  return (
    <div
      className={twMerge(
        'rounded border px-8 py-4 text-xs font-medium uppercase',
        getToneClasses(tone)
      )}
    >
      {label}
    </div>
  );
};
